import { GirafeSingleton } from '@geogirafe/lib-geoportal/base';
import { MapbsConfig } from '../config/mapbsconfig';

export default class ServerCacheManager extends GirafeSingleton {
  public get mapbsConfig() {
    return this.context.configManager.Config.extendedConfig as unknown as MapbsConfig;
  }

  public invalidateUserCache() {
    fetch(this.mapbsConfig.invalidateCacheUrl);
  }

  public handleCtrlClick(event: MouseEvent) {
    if (event.ctrlKey) {
      this.invalidateUserCache();
    }
  }
}
